import { Utils } from "../core/Utils";
import { uploadFile } from "../core/uploadFile";
import { AbstractSection } from "./AbstractSection";
import { Cookie } from "../core/Cookie";
import { simpleForm } from "../core/SimpleForm";
import { MediaData } from "@ts/data/MediaData";


export class AudioSection extends AbstractSection {

    public constructor(section:MediaData) {
        super( section );
        this.renderTarget.classList.add('audio-wrapper');
    }

    protected onViewRender(): void {

        const data = this.data as MediaData;
        this.renderTarget.innerHTML = Utils.minify(`
                <figure>
                    <audio src="${data.mediafile}" controls 
                    ${data.shadow?'class="shadow"':''}></audio>
                    <figcaption >${data.comment}</figcaption>
                </figure>
            `);
    }

    protected onEditRender(): void {

        const data = this.data as MediaData;
        this.renderTarget.innerHTML = Utils.minify(`
                <figure>
                    <audio src="${data.mediafile}" controls 
                    ${data.shadow?'class="shadow"':''}></audio>
                    <figcaption >${data.comment}</figcaption>
                </figure>
            `);

        if( this.tbar ) {
            this.tbar.add('Byt ljud', 
                'audio',
                `Klicka för att byta till en annan ljudfil. Ljudfilens storlek är begränsad till 32 MB. Den gränsen kan överskridas men då
                måste du kontakta mig <a href="mailto:roland@rstralberg.com">roland@rstralberg.com</a>`,
                () => {
                uploadFile('audio', Cookie.pagename)
                .then((resolve: string | false) => {
                    if (resolve) {
                        const audioElement = this.renderTarget.querySelector('audio') as HTMLAudioElement;
                        audioElement.src = resolve;
                        Utils.forceRefresh(audioElement);
                    }
                });
            });
            this.tbar.add('Ändra kommentar', 
                `Här kan du lägga till en kommentar. Vill du ingen ha så lämna skrivfältet tomt. Kommentaren
                kan vara fler än en rad om du så vill`,
                'comment', async () => {
                const commentElement = this.renderTarget.querySelector('figcaption') as HTMLElement;
                simpleForm('Audio', 4, 'Ändra kommentar', commentElement.innerText, 'Min kommentar')
                .then((text:string) => {
                    commentElement.innerText = text;
                    Utils.forceRefresh(commentElement);
                });
            });
            this.tbar.add('Växla skuggning',
                'Växlar skuggning av ljuduppspelaren',
                'shadow', () => {
                    const audioElement = this.renderTarget.querySelector('audio') as HTMLAudioElement;
                    Utils.toggleCss(audioElement,'shadow');
                });
            
        }
    }

    protected parseContent(): void {
        
        const audio = this.renderTarget.querySelector('audio') as HTMLAudioElement;
        (this.data as MediaData).mediafile = Utils.stripHost(audio.src);

        const figcaption = this.renderTarget.querySelector('figcaption') as HTMLElement;
        (this.data as MediaData).comment = figcaption.innerText;

        (this.data as MediaData).shadow = audio.classList.contains('shadow');

    }
}